'use strict';

var _createForOfIteratorHelper = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _regeneratorRuntime = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var EventEmitter = require('events');

var multiaddr = require('multiaddr');

var debug = require('debug');

var log = debug('libp2p:circuit:listener');
log.err = debug('libp2p:circuit:error:listener');
/**
 * @param {*} circuit
 * @returns {Listener} a transport listener
 */

module.exports = function (circuit) {
  var listener = new EventEmitter();
  var listeningAddrs = new Map();
  /**
   * Add swarm handler and listen for incoming connections
   *
   * @param {Multiaddr} addr
   * @return {void}
   */

  listener.listen = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(addr) {
      var addrString, relayConn, relayedAddr;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              addrString = String(addr).split('/p2p-circuit').find(function (a) {
                return a !== '';
              });
              _context.next = 3;
              return circuit._dialer.connectToPeer(multiaddr(addrString));

            case 3:
              relayConn = _context.sent;
              relayedAddr = relayConn.remoteAddr.encapsulate('/p2p-circuit');
              listeningAddrs.set(relayConn.remotePeer.toB58String(), relayedAddr);
              listener.emit('listening');

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
  /**
   * TODO: Remove the peers from our topology
   *
   * @return {void}
   */


  listener.close = function () {};
  /**
   * Get fixed up multiaddrs
   *
   * NOTE: This method will grab the peers multiaddrs and expand them such that:
   *
   * a) If it's an existing /p2p-circuit address for a specific relay i.e.
   *    `/ip4/0.0.0.0/tcp/0/ipfs/QmRelay/p2p-circuit` this method will expand the
   *    address to `/ip4/0.0.0.0/tcp/0/ipfs/QmRelay/p2p-circuit/ipfs/QmPeer` where
   *    `QmPeer` is this peers id
   * b) If it's not a /p2p-circuit address, it will encapsulate the address as a /p2p-circuit
   *    addr, such when dialing over a relay with this address, it will create the circuit using
   *    the encapsulated transport address. This is useful when for example, a peer should only
   *    be dialed over TCP rather than any other transport
   *
   * @return {Multiaddr[]}
   */


  listener.getAddrs = function () {
    var addrs = [];

    var _iterator = _createForOfIteratorHelper(listeningAddrs.values()),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var addr = _step.value;
        addrs.push(addr);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return addrs;
  };

  return listener;
};